import {create} from 'zustand';
import {couponApi} from '../services/api/couponApi';

export const useCouponStore = create((set) => ({
  coupons: [],
  isLoading: false,

  fetchCoupons: async () => {
    set({isLoading: true});
    try {
      const response = await couponApi.list();
      set({coupons: response.data.data});
    } finally {
      set({isLoading: false});
    }
  },

  createCoupon: async (data) => {
    const response = await couponApi.create(data);
    const newItem = response.data.data;
    set(state => ({coupons: [...state.coupons, newItem]}));
    return newItem;
  },

  updateCoupon: async (id, data) => {
    const response = await couponApi.update(id, data);
    const updated = response.data.data;
    set(state => ({
      coupons: state.coupons.map(c => (c.id === id ? updated : c)),
    }));
    return updated;
  },

  deleteCoupon: async (id) => {
    await couponApi.remove(id);
    set(state => ({
      coupons: state.coupons.filter(c => c.id !== id),
    }));
  },
}));
